export const useDecimalOddsSelector = ({ pageInfo }) => pageInfo.useDecimalOdds || false;

export const isPhoneSelector = ({ pageInfo }) => pageInfo.isPhone;

export const isTabletSelector = ({ pageInfo }) => pageInfo.isTablet;

export const apiUrlSelector = ({ pageInfo }) => pageInfo.apiUrl;

export const isBookmakerSwitcherOpenedSelector =
    ({ pageInfo }) => pageInfo.isBookmakerSwitcherOpened;




// WEBPACK FOOTER //
// /src/js/common/pageInfo/pageInfo.selectors.js